<mat-checkbox [checked]="table.isNonEmptyAndAllSelected()" (change)="table.toggleAllSelected()" (click)="$event.stopPropagation()"/>
